import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const AccountFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

export const Account = withAppProviders(AccountFrontend)();

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-account");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<Account />
			</Suspense>,
			element
		);
	}
});
